import Input from "../../../../components/Input/Input";

const String = ({id, formik, settings = {}}) => {
    return (
        <Input
            name={id}
            label={settings.title}
            required={settings.required}
            description={settings.description}
            formik={formik}
            layout="vertical"
        />
    )
};

export default String;